import { Autocomplete, TextField } from '@mui/material';
import { isNotNullOrUndefined } from '@vy/utils';
import type { Control, FieldValues, Path, PathValue } from 'react-hook-form';
import { Controller } from 'react-hook-form';

export const ControlledAutocomplete = <FormValues extends FieldValues>(props: {
  name: Path<FormValues>;
  control: Control<FormValues>;
  label: string;
  options: string[];
  placeholder?: string;
  defaultValue?: PathValue<FormValues, Path<FormValues>>;
}) => {
  const { name, control, label, options, placeholder, defaultValue } = props;

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field, fieldState: { error } }) => (
        <Autocomplete
          {...field}
          fullWidth
          autoHighlight
          options={options}
          value={field.value}
          onChange={(event, newValue) => {
            event.preventDefault();
            field.onChange(newValue ?? '');
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              placeholder={placeholder}
              helperText={error ? error.message : ''}
              error={isNotNullOrUndefined(error)}
              slotProps={{
                ...params.slotProps,

                htmlInput: {
                  ...params.slotProps.htmlInput,
                }
              }}
            />
          )}
        />
      )}
    />
  );
};
